import { useMemo } from 'react';
import { PackingTypeSale } from 'enums/packingTypeSale';
import { calculateMinBySaleType } from 'utils/util';
import { initialPackingSelectedState } from 'store/state/gfpOffer/gfpOfferStore';
import type Packing from 'model/Packing';

interface SaleInfo {
  min: number;
  max: number;
  availableLabel: string;
  inputLabel: string;
}


export const useProductSaleInfo = (
  selectedTypeSale: PackingTypeSale,
  packingSelected?: Packing
): SaleInfo => {
  return useMemo(() => {
    const getCurrentInfo = () => {
      switch (selectedTypeSale) {
        case PackingTypeSale.Layer:
          return {
            label: packingSelected?.maxAvailableLayersLabel || '',
            max: packingSelected?.maxAvailableLayersQuantity || 0,
          };
        case PackingTypeSale.Trolley:
          return {
            label: packingSelected?.maxAvailableTrolleysLabel || '',
            max: packingSelected?.maxAvailableTrolleysQuantity || 0,
          };
        default:
          return {
            label: packingSelected?.maxAvailablePackingsLabel || '',
            max: packingSelected?.maxAvailablePackingsQuantity || 0,
          };
      }
    };

    const info = getCurrentInfo();

    const inputLabelMap = {
      [PackingTypeSale.Packing]: 'Embalagem',
      [PackingTypeSale.Layer]: 'Camada',
      [PackingTypeSale.Trolley]: 'Carrinho',
    };

    return {
      min: calculateMinBySaleType(
        selectedTypeSale,
        packingSelected ?? initialPackingSelectedState,
      ),
      max: info.max,
      availableLabel: info.label,
      inputLabel: inputLabelMap[selectedTypeSale] || 'Un',
    };
  }, [selectedTypeSale, packingSelected]);
};